export default __webpack_public_path__ + "assets/images/icon-smile.0174784cb873d9121a019ab44aac2ecd.svg";